<template>
  <itisFooter v-bind="$attrs">
    <template #logo>
      <img
        class="logo"
        src="https://qiniu-uploads-cdn.charmdeer.com/uploaded/FiTEe8ozRUpi4WfYmyY7nvcq5Cxm/hotelux-logo.png"
        alt=""
      />
    </template>
    <template #content>
      <div class="contact-message">
        <div class="contact-message-title">{{ t("shell.footer.contact") }}</div>
        <div class="contact-message-text">
          <a class="context-email" href="mailto:hello@hotelux.com"
            >hello@hotelux.com</a
          >
        </div>
      </div>
      <div class="contact-list">
        <div class="contact-list-content">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="contact-list-item"
          >
            <a :href="item.url" target="_blank" rel="noopener noreferrer">
              <img :src="item.img" alt="" />
            </a>
          </div>
        </div>
      </div>
      <div class="contact-eqcode">
        <img
          src="https://qiniu-cdn.hotelux.com//uploaded/FtFaHZNUnOF-9d2keug5twcrFpCz/download.png"
        />
      </div>
    </template>

    <template #bottom>
      <div class="footer-bottom">{{ t("shell.footer.hoteluxCopyRight") }}</div>
    </template>
  </itisFooter>
</template>

<script setup lang="ts" name="Footer">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import itisFooter from "@/distributions/consumer/y/layout/components/Footer.vue";
const { t, locale } = useI18n();
const linkList = ref([
  {
    url: "https://www.facebook.com/HoteLux.Official",
    type: "facebook",
    img: "https://qiniu.hoteluxapp.com//FqKo1Yq5SvlhNdjwHy9x-yWVaHQk_19.png?imageView2/2/w/1920"
  },
  {
    url: "https://www.instagram.com/hotelux.official",
    type: "instagram",
    img: "https://qiniu.hoteluxapp.com//FtxtpYNh-qGsKy9OqQ5OpGYR747n_19.png?imageView2/2/w/1920"
  },
  {
    url: "https://www.tiktok.com/@hotelux.official",
    type: "tiktok",
    img: "https://qiniu.hoteluxapp.com//FsBl-l1T4GuYi3M2IBOT2op8hCBI_19.png?imageView2/2/w/1920"
  }
]);
const list = computed(() => {
  const newlinkList = linkList.value.map(item =>
    item.type === "instagram" && locale.value === "jp"
      ? { ...item, url: "https://www.instagram.com/hotelux.jp" }
      : item
  );
  return newlinkList;
});
</script>

<style lang="scss" scoped>
.contact-message {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  .company {
    color: #fff;
    font-size: 14px;
  }
  .contact-type {
    display: flex;
    column-gap: 28px;
  }
  .contact-message-title {
    font-size: 20px;
    line-height: 20px;
    color: #fff;
    font-family: var(--y-title-font);
  }
  .contact-message-text {
    font-size: 16px;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.8);
    font-family: var(--y-regular-font);
    text-decoration: underline;
  }
}
.logo {
  width: 145px;
  height: 50px;
}
.contact-list {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  .contact-list-content {
    display: flex;
    column-gap: 22px;
  }
  .contact-list-item {
    border-radius: 50%;
    cursor: pointer;
  }
  img {
    width: 36px;
    height: 36px;

    box-sizing: content-box;
  }
}
.contact-eqcode {
  width: 80px;
  height: 80px;
}
.contact-eqcode img {
  width: 100%;
  height: 100%;
}
:deep() {
  .footer-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 20px;
  }
}
.footer {
  padding-top: 20px;
  padding-bottom: 0;
  background-color: #131212;
}
.footer-bottom {
  font-size: 12px;
  line-height: 12px;
  color: rgba(255, 255, 255, 0.5);
  padding: 16px 0;
  text-align: center;
  font-family: lato;
  background-color: #282828;
}
</style>
